import { css } from '@emotion/react'
import { getThemeSpacing } from '../../styles/appTheme'
import APP_BREAKPOINTS, { minWindowWidth } from '../../styles/breakpoints'
import { palette } from '../../styles/colors'
import { APP_FONT } from '../../theme'

export const rootStyles = css({
    padding: getThemeSpacing(3),
    paddingTop: getThemeSpacing(1),
    paddingBottom: getThemeSpacing(1),
    maxWidth: 500,
    [minWindowWidth(APP_BREAKPOINTS.sm)]: {
        padding: getThemeSpacing(2),
    },
})
export const junkStyles = css({
    margin: 0,
    fontSize: '0.75rem',
    lineHeight: 1.66,
    marginBottom: getThemeSpacing(3),
    fontWeight: 600,
    color: palette.mfcWarning,
})
export const verificationStyles = css({
    margin: getThemeSpacing() + ' 0',
    color: palette.greenMFC,
    lineHeight: 1.66,
    letterSpacing: '0.0333em',
    fontSize: '0.75rem',
    fontWeight: 400,
})
export const refreshStyles = css({
    marginTop: getThemeSpacing(2),
    display: 'block',
    margin: 'auto',
})

export const reload = () => {
    location.reload()
}

export const eyeIconStyle = css({
    position: 'absolute',
    top: '16px',
    right: '16px',
    color: '#777',
    cursor: 'pointer',
})

export const validationWarningStyles = css({
    fontFamily: APP_FONT,
    fontWeight: 500,
})
